export const getMetricsRoute = '/employer/metrics/';
export const getSourceApplicationRoute = '/employer/applications/source/get/';
